import { render, staticRenderFns } from "./OxygenFontFamilyInput.vue?vue&type=template&id=34db9544&"
import script from "./OxygenFontFamilyInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenFontFamilyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports